import { io } from "socket.io-client";

// Draw sessions live on the LITE server (realtime host), same split as
// src/live/connection.js.
const LITE_URL = "https://tarbaa-lite.apis.just2labs.com";
// const LITE_URL = "http://localhost:8080";

/** Socket for the board: opens and owns a draw session per question. */
export const createDrawHostSocket = () =>
  io(`${LITE_URL}/draw`, { auth: { host: "create" } });

/** Socket for the phone that scanned the QR and holds the pen. */
export const createDrawerSocket = (code, drawerId) =>
  io(`${LITE_URL}/draw`, { auth: { code, drawerId } });
